module.exports = __webpack_public_path__ + "img/a302ddb.png";